// extracted by mini-css-extract-plugin
export default {"container":"sideMenu_container__3iiN9","title":"sideMenu_title__feni6"};